export const TaskKeys = {
	all: ["tasks"] as const,
	lists: () => [...TaskKeys.all, "list"] as const,
	infiniteList: (
		filterDatefrom?: string,
		filterDateto?: string,
		filterOnlyunsolved?: boolean,
		filterOnlysolved?: boolean,
		filterSortdesc?: boolean,
		pageSize?: number,
	) =>
		[
			...TaskKeys.lists(),
			"infinite",
			{
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				filterSortdesc,
				pageSize,
			},
		] as const,
	detail: (id: number | null) => [...TaskKeys.all, "detail", id] as const,
	workflows: (id: number | null) => [...TaskKeys.all, "workflows", id] as const,
};
